<template>
  <div class="the-navbar__user-meta flex items-center">
    <vs-dropdown
      vs-custom-content
      vs-trigger-click
      class="cursor-pointer header-profile-container"
      ><div class="vx-row">
        <img src="@/assets/images/icons/header-profile.svg" class="mr-3 ml-3" />
        <div class="text-left header-title leading-tight hidden sm:block">
          <p class="font-semibold mt-4">
            {{ capitalizeEveryWord(user.username) }}
          </p>
        </div>
      </div>
      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <router-link to="/profile">
            <li
              class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            >
              <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">{{ $t("label.anchor.profile") }}</span>
            </li>
          </router-link>
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="openCustomizerDrawer"
          >
            <feather-icon icon="SettingsIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{ $t("customers.label.settings") }}</span>
          </li>
          <vs-divider class="m-1" />
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{ $t("label.heading.logout") }}</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    activeUserInfo() {
      return this.$store.getters["auth/userDetail"];
    },
    getUserFullName() {
      return `${this.activeUserInfo.firstname} ${this.activeUserInfo.lastname}`;
    },
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout").then((resp) => {
        sessionStorage.removeItem("ngb:user");
        sessionStorage.removeItem("ngb:user_token");
        sessionStorage.removeItem("ngb:bearer_token");
        this.$router.push("/login");
      });
    },
    openCustomizerDrawer() {
      this.$store.dispatch("auth/toggleCustomizer", true);
    },
    capitalizeEveryWord(str) {
      return str
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
  },
};
</script>
<style lang="scss" scoped>
.header-profile-container {
  .header-title {
    letter-spacing: 2px;
    text-transform: uppercase !important;
  }
}
</style>
